<template>
  <div id="flip-item-status">
    <v-row
      align="end"
    >
      <v-col md=6>
        <v-card flat tile>
          <v-card-title>{{ adminAsset.title }}</v-card-title>
          <v-card-text>
            <v-img :src="adminAsset.images.find(i => i.type === 'mainImage').smallUri"></v-img>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md=6>
        <assetDetailsList></assetDetailsList>
      </v-col>
    </v-row>
    <assetOwners></assetOwners>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import assetDetailsList from '../components/AssetDetailsList'
  import assetOwners from '../components/AssetOwners.vue'

  export default {
    name: 'FlipInvestors',

    components: {
      assetDetailsList,
      assetOwners
    },

    computed: {
      ...mapGetters([
        'adminAsset',
        'adminAssetOwnership'
      ])
    },

    methods: {
      ...mapActions([
        'getAssetOwnershipByAssetId',
        'clearPurchaseHistoryForAsset'
      ])
    },

    async created() {
      await this.getAssetOwnershipByAssetId(this.adminAsset.id)
    }
  }
</script>
